import React from "react";
import { Flame, Thermometer, Snowflake } from "lucide-react";

// Phase 25.13ab — Engagement badge for visitor sessions.
// Renders HOT / WARM / COLD with appropriate color and an optional
// tooltip listing the underlying signals. Compact enough to drop into
// the existing drawer rows without breaking layout.
//
// Props:
//   engagement: {score: int, level: 'hot'|'warm'|'cold', signals: [str]}
//   compact (bool): show level + score only, no icon text. Default false.
export default function EngagementBadge({ engagement, compact = false }) {
  if (!engagement) return null;
  const { level = "cold", score = 0, signals = [] } = engagement;

  const config = {
    hot: {
      Icon: Flame,
      label: "HOT",
      cls: "border-[#FF3B30]/50 bg-[#FF3B30]/10 text-[#FF6B5C]",
    },
    warm: {
      Icon: Thermometer,
      label: "WARM",
      cls: "border-[#FFB000]/40 bg-[#FFB000]/10 text-[#FFB000]",
    },
    cold: {
      Icon: Snowflake,
      label: "COLD",
      cls: "border-zinc-800 bg-zinc-950/40 text-zinc-500",
    },
  }[level] || { Icon: Snowflake, label: level.toUpperCase(), cls: "border-zinc-800 text-zinc-500" };

  const Icon = config.Icon;
  const title = signals.length > 0
    ? `Score ${score} · ${signals.join(" · ")}`
    : `Score ${score}`;

  return (
    <span
      className={`font-mono text-[9px] uppercase tracking-widest border ${config.cls} px-1.5 py-px flex items-center gap-1 flex-shrink-0`}
      title={title}
      data-testid={`engagement-${level}`}
    >
      <Icon className="w-2.5 h-2.5" />
      {config.label}
      {!compact && <span className="text-current/80">·{score}</span>}
    </span>
  );
}
